<script setup lang="ts">
import { ref, computed } from "vue"
import AppModal from '~/components/ui/modal/AppModal.vue'
import SectionContent from '~/components/sections/SectionContentTermOfUse/SectionContent.vue'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)

const showModalDJTerm = ref(false)
function toggleModalDJTerm(val: boolean) {
  showModalDJTerm.value = val
}
defineExpose({
  toggleModalDJTerm,
})
</script>

<template>
  <AppModal :show="showModalDJTerm" :showFooter="false" @closeModal="toggleModalDJTerm">
    <template #header>
      <div class="flex justify-between items-center">
        <div class="black fs-16 lh-16 fw-700">
          {{ dataTrip?.cancellation_policy?.has_policy ? 'Custom Terms and Conditions' : 'Designer Journeys Terms Of Use' }}
        </div>
      </div>
    </template>
    <template #body>
      <SectionContent v-if="!dataTrip?.cancellation_policy?.has_policy" class="popup-term"></SectionContent>
      <div class="lh-24 mb-10" v-else v-html="dataTrip?.cancellation_policy?.policy"></div>
      <span class="new-link lh-24">
        <a class="new-link" href="/terms-of-use" target="_blank">See Designer Journeys' Terms and Conditions</a>
      </span>
    </template>
  </AppModal>
</template>

<style lang="scss" scoped></style>
